import React from 'react';
import {IconoMensajes} from './IconoMensajes';
import {IconoNotificaciones} from './IconoNotificaciones';
import {useNavigate} from 'react-router-dom';

export const ViewHeader = (props) => {
	const navigate = useNavigate();
	/* Destructuring the props object. */
	const {
		goToInicioMarket,
		logAdperHeader,
		goLogin,
		goToNotificaciones,
		Usuario,
		setUsuario,
		MenuLateral,
		setMenuLateral,
		goToPerfil,
		goToHistorial,
		goToMonitor,
		cerrarSesion,
		goToMensajes,
		gotToMiEmpresa,
		goToMisPacientes,
		goToHome,
		chageMenuLateralAux,
	} = props;
	return (
		<>
			{
				/* Checking if the user is undefined, if it is, it sets the user to a default user. */
				Usuario === undefined &&
					setUsuario({
						tipo: 'noRegistrado',
						userName: '',
						email: '',
						imagen: '',
						litaCarrito: [],
					})
			}

			<div className='header centrador'>
				<div className='centrador-der-header'>
					{Usuario.tipo !== undefined && Usuario.tipo !== 'noRegistrado' && (
						<div className='centrador'>
							{' '}
							<div
								className='centrador menu-header'
								onClick={() => {
									if (
										Usuario.tipo === 'usuarioEmpresa' ||
										Usuario.tipo === 'usuarioAdmin' ||
										Usuario.tipo === 'usuarioNormal'
									) {
										chageMenuLateralAux();
									} else {
										setMenuLateral(!MenuLateral);
									}
								}}
							>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='24'
									height='24'
									fill='currentColor'
									className='bi bi-list'
									viewBox='0 0 16 16'
								>
									<path
										fillRule='evenodd'
										d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'
									/>
								</svg>
							</div>
						</div>
					)}
					<div
						className='centrador'
						onClick={goToInicioMarket}
					>
						<img
							src={logAdperHeader}
							alt='LogoAdiper'
							className='hijo logoAdiperHeader'
						/>
					</div>
				</div>
				{
					/* Checking if the user is not logged in, if it is not, it shows the login button. */
					Usuario.tipo === 'noRegistrado' && (
						<div className='centrador'>
							<div class='row'>
								<div
									className='login-boton col-lg-2 col-sm-2 col-xs-2 centrador button'
									style={{margin: '2px'}}
									onClick={goLogin}
								>
									Necesito cuidados
								</div>
								<div
									className='login-boton col-lg-2 col-sm-2 col-xs-2 centrador button'
									style={{margin: '2px'}}
									onClick={() => navigate('/loginEmpresa')}
								>
									Ofrecemos cuidados
								</div>
							</div>
						</div>
					)
				}

				{
					/* Checking if the user is logged in, if it is, it shows the user's profile picture,
                    the messages icon and the notifications icon. */
					Usuario.tipo !== 'noRegistrado' && (
						<div className='infoUsu'>
							<IconoMensajes
								numMensajes={Usuario.messages}
								goToMensajes={goToMensajes}
							/>
							<IconoNotificaciones
								goToNotificaciones={goToNotificaciones}
								numMensajes={Usuario.messages}
							/>
						</div>
					)
				}
			</div>
		</>
	);
};
